<div class="flex flex-col container">
  <h2>Service History</h2>
  <sha-service-history [serviceHistory$]="serviceLaneFacade.serviceHistory$"></sha-service-history>
</div>